import dayjs from "dayjs";
import { getCurrentSpaceData } from "../../utils/currentUserDetail.js";
import injectDataInTemplate from "../../utils/extractWidget.js";
import { getFormattedDate } from "../../utils/getLocalFormattedDate.js";
import { isDateObject } from "../../utils/safeDate.js";
import axios from "axios";

export const triggerNotification = (params) => {
    const {
        recipients={user: [], group: []},
        notificationParams,
        template,
        userInfo,
        currentStepInfo = null,
        spaceSpecificGroups = [],
        spaceSpecificUsers = [],
        userGroupSpaces = [],
        formItems=[]
    } = params;

    if (!template?.enabled) {
        return null;
    }

    let recipientUsers = Array.isArray(recipients?.user) ? recipients.user : []
    let recipientGroups = Array.isArray(recipients?.group) ? recipients.group : []
    if (recipientUsers.length === 0 && recipientGroups.length === 0) {
        return null;
    }

    let notificationApi = `${process.env.REACT_APP_BACKEND_API}/trigger-email`
    let _notificationParams = { ...notificationParams }
    let emailLink = window.location.origin + _notificationParams.redirectUrl + "?redirectFrom=mail"
    let spaceId = notificationParams["spaceId"]
    if (!notificationParams["Space name"]) {
        let spaceInfo = getCurrentSpaceData(spaceId, userInfo.spaceInfo, userGroupSpaces)
        _notificationParams = {
            ..._notificationParams,
            ["Space name"]: spaceInfo?.name,
        }
    }
    Object.keys(_notificationParams).forEach(value => {
        let currentValue = _notificationParams[value] || ""

        if (Array.isArray(currentValue)) {
            _notificationParams[value] = currentValue.join(", ")
        } else if (typeof currentValue === "object" && (currentValue.user || currentValue.group || currentValue.userPicker)) {
            let userWidgetValues = [];
            if (currentValue.user?.length > 0) {
                let userArr = currentValue.user.map(email => {
                    let userInfo = spaceSpecificUsers.find(user => user.email === email)
                    return userInfo?.name || email
                })
                userWidgetValues.push(userArr)
            }
            if (currentValue.group?.length > 0) {
                let groupArr = currentValue.user.map(email => {
                    let groupInfo = spaceSpecificGroups.find(group => group.email === email)
                    return groupInfo?.name || email
                })
                userWidgetValues.push(groupArr)
            }
            _notificationParams[value] = userWidgetValues.join(", ")
        }
        if (isDateObject(currentValue) && value !== "Request Id" && value !== "Chatroom message") {
            _notificationParams[value] = getFormattedDate(currentValue)
        }
    })

    // uniqueRecipients.map((user) => {
    _notificationParams = {
        ..._notificationParams,
        "Recipient": "@Recipient",
        "Last updater": userInfo.name,
        // "Workflow step": currentStepInfo?.data?.name
    }
    let languageSpecificData = {}

    if (template?.languageSpecific) {
        let uniqLangs = Object.keys(template?.languageSpecific)
        uniqLangs.map(uniqLang => {
            let subject = template.languageSpecific[uniqLang].subject ? injectDataInTemplate(template.languageSpecific[uniqLang].subject, _notificationParams, formItems) : ''

            let content = injectDataInTemplate(template.languageSpecific[uniqLang].body, _notificationParams, formItems)
            if (subject) {
                try {
                    const parser = new DOMParser();
                    let parsedSubject = parser.parseFromString(subject, 'text/html');
                    subject = parsedSubject.documentElement.innerText
                } catch (error) {

                }
            }
            if (content) {
                try {
                    const parser = new DOMParser();
                    let parsedContent = parser.parseFromString(content, 'text/html');
                    if (parsedContent) {
                        const bodyElement = parsedContent.querySelector("body");
                        if (bodyElement) {
                            bodyElement.style.maxWidth = '650px';
                            bodyElement.style.margin = 'auto';
                        }
                        let anchorTag = parsedContent.querySelector(`[action-link="OPEN_THE_DOCUMENT"]`)
                        if (anchorTag) {
                            anchorTag.setAttribute("href", emailLink)
                        }
                        content = parsedContent.documentElement.innerHTML
                    }
                } catch (error) {

                }
            }
            languageSpecificData = {
                ...languageSpecificData,
                [uniqLang]: { subject, content }
            }
        })
    }
    let postData = {
        redirectUrl: notificationParams.redirectUrl,
        userId: userInfo.userId,
        languageSpecific:
            languageSpecificData,
        sendEmail: true,
        to: [
            { recipientType: "user", data: recipientUsers },
            { recipientType: "group", data: recipientGroups }
        ],
        notificationType: template.notificationType,
        spaceId: spaceId
    }
    axios.post(notificationApi, postData, {
        headers: {
            tenantId: 1
        },
    }).then(res => {

    })
    // })
}
